/* tslint:disable */
/* eslint-disable */
/**
 * IbanOplata.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { IbanInvoiceExpirationDto } from '../models';
// @ts-ignore
import type { IbanInvoiceExpirationSetCommand } from '../models';
// @ts-ignore
import type { ProblemDetails } from '../models';
/**
 * InvoiceExpirationSettingsApi - axios parameter creator
 * @export
 */
export const InvoiceExpirationSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsInvoiceExpirationGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/invoice-expiration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IbanInvoiceExpirationSetCommand} [ibanInvoiceExpirationSetCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsInvoiceExpirationPost: async (ibanInvoiceExpirationSetCommand?: IbanInvoiceExpirationSetCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/invoice-expiration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ibanInvoiceExpirationSetCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceExpirationSettingsApi - functional programming interface
 * @export
 */
export const InvoiceExpirationSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceExpirationSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSettingsInvoiceExpirationGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanInvoiceExpirationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSettingsInvoiceExpirationGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceExpirationSettingsApi.apiSettingsInvoiceExpirationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IbanInvoiceExpirationSetCommand} [ibanInvoiceExpirationSetCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSettingsInvoiceExpirationPost(ibanInvoiceExpirationSetCommand?: IbanInvoiceExpirationSetCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanInvoiceExpirationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSettingsInvoiceExpirationPost(ibanInvoiceExpirationSetCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceExpirationSettingsApi.apiSettingsInvoiceExpirationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoiceExpirationSettingsApi - factory interface
 * @export
 */
export const InvoiceExpirationSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceExpirationSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsInvoiceExpirationGet(options?: RawAxiosRequestConfig): AxiosPromise<IbanInvoiceExpirationDto> {
            return localVarFp.apiSettingsInvoiceExpirationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IbanInvoiceExpirationSetCommand} [ibanInvoiceExpirationSetCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsInvoiceExpirationPost(ibanInvoiceExpirationSetCommand?: IbanInvoiceExpirationSetCommand, options?: RawAxiosRequestConfig): AxiosPromise<IbanInvoiceExpirationDto> {
            return localVarFp.apiSettingsInvoiceExpirationPost(ibanInvoiceExpirationSetCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceExpirationSettingsApi - object-oriented interface
 * @export
 * @class InvoiceExpirationSettingsApi
 * @extends {BaseAPI}
 */
export class InvoiceExpirationSettingsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceExpirationSettingsApi
     */
    public apiSettingsInvoiceExpirationGet(options?: RawAxiosRequestConfig) {
        return InvoiceExpirationSettingsApiFp(this.configuration).apiSettingsInvoiceExpirationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IbanInvoiceExpirationSetCommand} [ibanInvoiceExpirationSetCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceExpirationSettingsApi
     */
    public apiSettingsInvoiceExpirationPost(ibanInvoiceExpirationSetCommand?: IbanInvoiceExpirationSetCommand, options?: RawAxiosRequestConfig) {
        return InvoiceExpirationSettingsApiFp(this.configuration).apiSettingsInvoiceExpirationPost(ibanInvoiceExpirationSetCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

